// Утилиты для работы с флагами

// Функция для получения флага по коду страны из настроек
export const getFlagByCode = (flagCode) => {
  try {
    // Пытаемся загрузить SVG флаг
    return require(`../img/flagicons/${flagCode}.svg`).default || require(`../img/flagicons/${flagCode}.svg`);
  } catch (error) {
    // Если флаг не найден, возвращаем флаг со знаком вопроса по умолчанию
    try {
      return require(`../img/flagicons/unknown.svg`).default || require(`../img/flagicons/unknown.svg`);
    } catch (fallbackError) {
      // Если даже флаг по умолчанию не найден, возвращаем null
      console.warn(`Flag not found: ${flagCode}, fallback also failed`);
      return null;
    }
  }
};

// Функция для получения флага из настроек сайта
export const getCurrentFlag = (siteSettings) => {
  const flagCode = siteSettings?.selectedFlag || 'my';
  return getFlagByCode(flagCode);
};